<template lang="html">
  <div class="succeed">
    <!-- <div v-title data-title="我是新的标题"></div> -->
    <div class="" v-if="this.examList.length == 1">
      <div class="head_text" >
        您本次测试数据为
      </div>
      <div class="myself_once_grade" v-show="examListShow">
        <div class="myself_grade">
          <div class="">
            <img src="../../assets/image/exam/ranking.png" alt="">
            <p>{{firstExamList[0].rank || "-"}}名</p>
          </div>
          <div class="">
            <img src="../../assets/image/exam/grade.png" alt="">
            <p>{{firstExamList[0].score || "-"}}分</p>
          </div>
          <div class="">
            <img src="../../assets/image/exam/time.png" alt="">
            <p>{{firstExamList[0].use_time || "-"}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="" v-show="examListShow" v-else>
      <div class="head_text">
        您最终测试数据为
      </div>
      <div class="myself_once_grade">
        <div class="myself_grade" v-if="examList[0].rank < examList[1].rank">
          <div class="">
            <img src="../../assets/image/exam/ranking.png" alt="">
            <p>{{examList[0].rank}}名</p>
          </div>
          <div class="">
            <img src="../../assets/image/exam/grade.png" alt="">
            <p>{{examList[0].score}}分</p>
          </div>
          <div class="">
            <img src="../../assets/image/exam/time.png" alt="">
            <p>{{examList[0].use_time}}</p>
          </div>
        </div>
        <div class="myself_grade" v-else>
          <div class="">
            <img src="../../assets/image/exam/ranking.png" alt="">
            <p>{{examList[1].rank}}名</p>
          </div>
          <div class="">
            <img src="../../assets/image/exam/grade.png" alt="">
            <p>{{examList[1].score}}分</p>
          </div>
          <div class="">
            <img src="../../assets/image/exam/time.png" alt="">
            <p>{{examList[1].use_time}}</p>
          </div>
        </div>
        <div class="history_grade" @click="getRankList">
          查看历史成绩
        </div>
      </div>
    </div>

    <!-- 历史成绩 -->
    <div class="" v-show="rankListShow">
      <div class="head_text">
        您测试历史成绩为
      </div>
      <div class="myself_once_grade">
        <div class="look_all_grade">
          <div class="myself_all_grade" v-for="(a,index) in examList" :key="index">
            <p style="width: 20%" class="myself_number">{{a.rank}}名</p>
            <p style="width: 15%">{{a.score}}分</p>
            <p style="width: 25%">{{a.use_time}}</p>
            <p style="width: 37%">{{a.create_time}}</p>
          </div>
        </div>
        <div class="history_grade_2" @click="getExamList">
          查看最终成绩
        </div>
      </div>
    </div>

    <!-- 二维码 -->

    <div class="grade_list">
      <div class="acyivity_ma" v-show="acyivityShow">
        <img :src="detailsIist.qrcode" alt="">
      </div>
      <div class="list_title">
        <div class="title_time">
          <p>排行榜</p>
          <p class="this_time">{{thisTime}}</p>
        </div>
        <div class="refresh" @click="refreshBtn">
          <img src="../../assets/image/exam/refresh.png" alt="">
          <p>刷新</p>
        </div>
      </div>
      <ul class="grade_con">
        <li class="grade_nav">
          <div class="list_nav_number">排名</div>
          <div class="list_nav_name">姓名</div>
          <div class="list_nav_grade">分数</div>
          <div class="list_nav_time">时间</div>
        </li>
        <li class="rank_list" v-for="(a, index) in rankList" :key="index">
          <div class="list_number">
            <div class="" v-if="index + 1 == 1">
              <img src="../../assets/image/exam/number_1.png" alt="">
            </div>
            <div class="" v-else-if="index + 1 == 2">
              <img src="../../assets/image/exam/number_2.png" alt="">
            </div>
            <div class="" v-else-if="index + 1 == 3">
              <img src="../../assets/image/exam/number_3.png" alt="">
            </div>
            <div class="" v-else>
              {{index + 1}}
            </div>
          </div>
          <div class="list_name">{{a.user_name}}</div>
          <div class="list_grade">{{a.score}}</div>
          <div class="list_time">{{a.use_time}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'

export default {
  data(){
    return{
			detailsIist: '',
      firstExamList: [
        {rank : ''}
      ],
      examList : [
        {rank : ''}
      ],
      thisTime: '',
      examListShow : true,
      rankList : [],
      rankListShow : false,
      acyivityShow: false,
    }
  },
  created(){

  },
  mounted(){
		this.init()
    // 获取当前时间
    let myDate = new Date();
    this.thisTime = '(截止 ' + myDate.getFullYear() + '.' + (myDate.getMonth()+1) + '.' + myDate.getDate() + ' ' + myDate.getHours() + ':' + myDate.getMinutes() + ')';
    this.getResultList();
  },
  methods:{
		init(){
			this.details();
		},
		// 获取测试须知内容  试卷title
		details(){
			this.$http({
				url: '/paper/getPaperAuthType',
				method: 'get',
				params: {
					task_id: this.$route.query.task_id,
				},
			}).then((res) => {
				if(res.code >= 0){
					this.$nextTick(function(){
						this.title = res.data.title;
					},0);
					this.detailsIist = res.data;
				}
			})
		},
    getResultList(){
      this.$http({
        url: "/paper/testRank",
        method: 'get',
        params: {
          task_id: this.$route.query.task_id,
          user_unique_id: this.$route.query.phone,
          auth_code: this.$route.query.auth_code,
        },
      }).then((res) => {
        if(res.data.exam_list.length == 1){
          this.firstExamList = res.data.exam_list;
          if(this.firstExamList[0].rank != ''){
            this.acyivityShow = true;
          }
        }else{
          this.examList = res.data.exam_list;
          if(this.examList[0].rank != '' && this.examList[1].rank != ''){
            this.acyivityShow = true;
          }
        }

        this.rankList = res.data.rank_list;
      })
    },
    getRankList(){
      this.examListShow = false;
      this.rankListShow = true;
    },
    getExamList(){
      this.examListShow = true;
      this.rankListShow = false;
    },
    refreshBtn(){
      this.getResultList();
    }
  }
}
</script>

<style lang="css" scoped>
.succeed{
  position: relative;
  margin: auto;
  width: 100%;
  background: url("../../assets/image/exam/succeed_back.png");
  background-size: 100%;
  background-repeat: no-repeat;
  /* overflow: auto; */
  /* padding: 0 1.5rem; */
  box-sizing: border-box;
  /* padding-top: 2rem; */
  /* overflow: hidden; */
}
.head_text{
  box-sizing: border-box;
  padding: 6rem 1.5rem 2.4rem 1.5rem;
  color: #FFF;
  font-size: 2.4rem;

}
.myself_once_grade{
  /* height: 8rem; */
  background-color: #FFF;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  border-radius: 1rem;
  position: relative;
  z-index: 5;
  box-shadow: 0px 0px 10px -2px rgba(0, 0, 0, 0.1);
  padding-bottom: 1.3rem;
}
.look_all_grade{
  /* font-size: */
}
.myself_all_grade{
  text-align: center;
  display: flex;
  font-size: 1.4rem;
  padding-top: 1.4rem;
}
.myself_all_grade p {
  line-height: 2.4rem;
}
.myself_number{
  font-size: 1.8rem;
  color: #4929B1;
}
.myself_grade{
  display: flex;
  justify-content: center;
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
}
.myself_grade div{
  width: 30%;
  text-align: center;
  color: #4929B1;
  font-size: 1.8rem;
  font-weight: 600;
}
.myself_grade img{
  width: 3.4rem;
}
.history_grade{
  width: 14rem;
  height: 2.4rem;
  line-height: 2.4rem;
  margin: auto;
  border: .1rem solid #4929B1;
  border-radius: 1.2rem;
  text-align: center;
  font-size: 1.4rem;
  color: #4929B1;
}
.history_grade_2{
  width: 14rem;
  height: 2.4rem;
  line-height: 2.4rem;
  margin: auto;
  border: .1rem solid #4929B1;
  border-radius: 1.2rem;
  text-align: center;
  font-size: 1.4rem;
  color: #4929B1;
  margin-top: 1.1rem;
}
.grade_list{
  box-sizing: border-box;
  width: 100%;
  background-color: #FFF;
  border-radius: 1.5rem 1.5rem 0 0;
  margin-top: -4rem;
  padding: 5rem 1.5rem 2rem 1.5rem;
}
.acyivity_ma{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 1.4rem;
  color: #4929B1;
}
.acyivity_ma img{
  width: 28rem;
  margin-top: .5rem;
  margin-bottom: .5rem;
}
.list_title{
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}
.title_time{
  font-size: 1.8rem;
  color: #3C3B3F;
  display: flex;
  align-items: flex-end;
  font-weight: 600;
}
.this_time{
  font-size: 1.2rem;
  color: #707071;
  font-weight: 400;
  margin-left: .5rem;
}
.refresh{
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  color: #0592FA;
}
.refresh img{
  width: 1.8rem;
  height: 1.8rem;
  margin-right: .5rem;
}
.grade_con{
  margin-top: 1rem;
}
.grade_nav{
  display: flex;
  justify-content: space-between;
  font-size: 1.4rem;
  margin-top: 1rem;
  overflow: auto;
  color: #C3C3C3;
}
.list_nav_number{
  width: 10%;
  text-align: left;
}
.list_nav_name{
  width: 40%;
}
.list_nav_grade{
  width: 20%;
  text-align: center;
}
.list_nav_time{
  width: 20%;
  text-align: right;
}



.rank_list{
  display: flex;
  justify-content: space-between;
  font-size: 1.4rem;
  margin-top: 1rem;
}
.list_number{
  width: 10%;
  height: 2.8rem;
  line-height: 2.8rem;
  text-align: center;
  color: #C3C3C3;
}
.list_number img{
  width: 2.8rem;
}
.list_name{
  width: 40%;
  height: 2.8rem;
  line-height: 2.8rem;
}
.list_grade{
  width: 20%;
  height: 2.8rem;
  line-height: 2.8rem;
  text-align: center;
}
.list_time{
  width: 20%;
  height: 2.8rem;
  line-height: 2.8rem;
  text-align: center;
}
</style>
